import { useSession } from "next-auth/react";
import { TrashIcon } from "@heroicons/react/24/outline";
import Grid from "../components/Grid";
import Layout from "../components/Layout";
import {
  useDeleteWatchlistMutation,
  useGetUserWatchlistQuery,
} from "../graphql/generated/graphql";
import { classNames } from "../utils/formatters";
import { GET_USER_WATCHLIST } from "../graphql/queries/watchlist";
import WatchlistEmptyState from "../components/WatchlistEmptyState";
import FavoriteSearches from "../components/FavoriteSearches";
import SEO from "../components/SEO";

export default function Favorites() {
  const { data: session, status: sessionStatus } = useSession();

  const {
    data,
    loading: loadingWatchlist,
    error,
  } = useGetUserWatchlistQuery({
    skip: sessionStatus !== "authenticated",
  });

  const [deleteWatchlist, { loading: deletingWatchlist }] =
    useDeleteWatchlistMutation({
      refetchQueries: [{ query: GET_USER_WATCHLIST }],
    });

  const loading =
    loadingWatchlist || deletingWatchlist || sessionStatus === "loading";

  return (
    <>
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/favorites`}
        title="Favoritos"
        siteTitle="Movi Autos"
      />
      <main className="max-w-7xl mx-auto pt-6 sm:pt-10">
        <div className="flex justify-between px-4">
          <div>
            <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 h-">
              Autos Favoritos
            </h2>
          </div>
          {data?.getUserWatchlist?.length ? (
            <div className="flex items-center">
              <div className="flex items-center mr-5">
                <div className="flex items-center">
                  <TrashIcon
                    className={classNames(
                      "text-gray-900",
                      "h-5 w-5 flex-shrink-0"
                    )}
                    aria-hidden="true"
                  />
                </div>
                <p className="sr-only">Eliminar todos</p>
                <button
                  className="ml-2 text-sm font-medium text-orange-500 hover:text-orange-400 disabled:opacity-40 disabled:cursor-not-allowed"
                  disabled={loadingWatchlist || deletingWatchlist}
                  onClick={() => deleteWatchlist()}
                >
                  Eliminar todos
                </button>
              </div>

              <span className="relative z-0 inline-flex shadow-sm rounded-md">
                <button
                  type="button"
                  className="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-gray-50 text-sm font-medium text-orange-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:opacity-40 disabled:cursor-not-allowed"
                  disabled={loading}
                >
                  Activos
                </button>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:opacity-40 disabled:cursor-not-allowed"
                  disabled={loading}
                >
                  Expirados
                </button>
              </span>
            </div>
          ) : null}
        </div>
        <Grid
          loading={loading}
          items={data?.getUserWatchlist}
          EmptyStateComponent={WatchlistEmptyState}
        />
        <FavoriteSearches />
      </main>
    </>
  );
}

Favorites.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};
